
import * as React from "react";
import { ISetUrl } from "../../AppMain";
import Header from "../Header";
import Footer from "../Footer";
import { Lng } from "../../../languages/Languages";
import Config from "../../Config";

interface IPrivacyPolicyProps {
    setUrl:ISetUrl
}

interface IPrivacyPolicyState {
}

export default class PrivacyPolicy extends React.Component<IPrivacyPolicyProps, IPrivacyPolicyState>{

    constructor(props:IPrivacyPolicyProps){
        super(props);
    }

    render() {
        setTimeout(() => {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }, 80);
        return (
            <>
                <Header
                    setUrl={this.props.setUrl}
                    title={Lng.get("user_profile_privacypol")}
                ></Header>
                <section className="content_section container" style={{fontSize:'12px'}}>
                    { Config.getLang()==="en"?this.getEn():this.getHu()}
                </section>
                <section className="content_section container" style={{fontSize:'12px'}}>

                </section>
                <Footer setUrl={this.props.setUrl}></Footer>
			</>
        );
    }
    private getHu(){
        return <>
            <p style={{textAlign:'center'}}>Adatvédelmi Tájékoztató</p>

            <p style={{textAlign:'center'}}>&nbsp;</p>

            <p style={{textAlign:'center'}}>Consil Korlátolt Felelősségű Társaság<br />
            http://sobras.us</p>

            <p style={{textAlign:'center'}}>&nbsp;</p>

            <p style={{textAlign:'center'}}>Hatályos: 2019. december 01. napjától</p>



            <p><strong>1. BEVEZETÉS</strong></p>


            <p>A Consil Korlátolt Felelősségű Társaság (a továbbiakban: Adatkezelő), mint a http://sobras.us cím alatt elérhető honlap, valamint a Sobras! rendszer&nbsp; üzemeltetője a jelen adatvédelmi tájékoztató útján tájékoztatja a honlap valamint a rendszer felhasználóit (a továbbiakban: felhasználó) és partnereit (a továbbiakban: Partner) (a továbbiakban együttesen: érintettek) adatkezelési tevékenységéről, az általa kezelt személyes adatok köréről, a személyes adatok kezelése során követett elvekről és gyakorlatról, adatfeldolgozók igénybevételéről, valamint az érintetti jogok gyakorlásának módjáról és lehetőségeiről.</p>


            <p>Adatkezelő a rendelkezésére bocsátott személyes adatokat az alábbi jogszabályokkal összhangban kezeli:</p>


            <p><em>Az Európai Parlament és a Tanács (EU) 2016/679 rendelete (2016. április 27.) – a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről (általános adatvédelmi rendelet, GDPR);</em></p>


            <p><em>2011. évi CXII. törvény - az információs önrendelkezési jogról és az információszabadságról (Infotv.);</em></p>

            <p><em>2013. évi V. törvény – a Polgári Törvénykönyvről (Ptk.);</em></p>

            <p><em>1997. évi CLV. törvény – a fogyasztóvédelemről (Fgytv.);</em></p>

            <p><em>2000. évi C. törvény – a számvitelről (Számv. tv.);</em></p>

            <p><em>2008. évi XLVIII. törvény – a gazdasági reklámtevékenység alapvető feltételeiről és egyes korlátairól;</em></p>

            <p><em>2001. évi CVIII. törvény – az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről (Eker. tv.)</em></p>


            <p>Adatkezelő kötelezettséget vállal arra, hogy tevékenységével kapcsolatos minden adatkezelés megfelel a jelen tájékoztatóban és a hatályos jogszabályokban meghatározott elvárásoknak.</p>


            <p>Adatkezelő fenntartja a jogot az adatvédelmi tájékoztató tartalmának módosítására, melyek eredményeként bekövetkezett változásokról előzetesen értesíti az érintetteket.</p>





            <p><strong>Az adatkezelő adatai:</strong></p>


            <p>Cégnév: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sobras Inc.</p>

            <p>Székhely: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1600 Wilson Blvd, Ste 820. Arlington, VA, USA</p>

            <p>Cégjegyzékszám: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fővárosi Törvényszék Cégbírósága; 01-09-194441</p>

            <p>Adószám: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 81-3817218</p>

            <p>Számlavezető pénzintézet: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wells Fargo</p>

            <p>Telefon: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; +36709335600</p>

            <p>Elektronikus levélcím:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; info@sobras.us</p>




            <p><strong>2. AZ ADATKEZELÉS ELVEI</strong></p>


            <p>Az adatvédelmi tájékoztatóval érintett adatkezelési tevékenységek elsődlegesen az elérhető kedvezményes Partneri szolgáltatások Sobras! rendszer segítségével történő megjelenítése, valamint a megrendeléssel létrejött szerződés teljesítése, továbbá kapcsolattartás céljából történnek, és önkéntes hozzájáruláson, szerződéses valamint jogszabályi kötelezettségeken alapulnak.</p>


            <p>Az Adatkezelő rendelkezésére bocsátott adatok helyességéért, pontosságáért és időszerűségéért – tekintettel arra, hogy azokat nem az Adatkezelő adja meg – az adatközlő személyek felelősek.</p>


            <p>Adatkezelő felhívja az adatközlők figyelmét, hogy amennyiben nem csak saját személyes adataikat adják meg, az adatközlő kötelessége és felelőssége a további érintett hozzájárulásának beszerzése.</p>


            <p>Adatkezelő a rendelkezésére bocsátott személyes adatokat bizalmasan, az adatvédelmi tájékoztatóban leírtak szerinti célból és módon kezeli, azokat más részére kizárólag a jelen adatvédelmi tájékoztatóban meghatározott okból adja át adatfeldolgozás vagy adatkezelés céljából.</p>



            <p><strong>3. EGYES ADATKEZELÉSEK</strong></p>


            <p><strong>3.1. ADATEZELÉS A SOBRAS.US HONLAPON</strong></p>


            <p><strong>3.1.1. A HONLAP MEGTEKINTÉSÉVEL KAPCSOLATOS TECHNIKAI ADATKEZELÉS</strong></p>


            <p>A sobras.us honlapra érkező felhasználók egyes technikai jellegű adatai automatikusan naplózásra kerülnek a tárhelyszolgáltató szerverén.</p>


            <p><strong>Adatkezelés célja:</strong> a honlap technikai üzemeltetése, a felhasználók egymástól való megkülönböztetése, a felhasználók aktuális munkamenetének azonosítása az oldal megfelelő működése céljából.</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bekezdés a) pontja alapján az érintett hozzájárulása</p>


            <p><strong>Érintettek köre:</strong> a honlap valamennyi látogatója</p>


            <p><strong>Kezelt adatok köre:</strong> IP cím, böngésző, operációs rendszer adatai, meglátogatott oldal címe és a látogatás időpontja.</p>


            <p><strong>Adatkezelés időtartama:</strong> 1 hét</p>


            <p><strong>Adatfeldolgozó: </strong>e-Communications Kft.</p>



            <p><strong>3.1.2. COOKIE KEZELÉS</strong></p>


            <p>A Honlap felkeresésekor webanalitikai rendszer üzemeltetése érdekében a Google Analytics kezel cookie-t.</p>


            <p>Cookie-k engedélyezése esetén a honlap megtekintésével kis méretű adatcsomagok kerülnek a felhasználó számítógépén elhelyezésre. A cookie-k célja, hogy az oldal felhasználóinak kényelmét szolgálják, az oldal használatát egyszerűbbé és élvezetesebbé tegyék. Ezen adatok naplózását a rendszer folyamatosan végzi, de nem kapcsolja össze a szolgáltatás igénybevétele során megadott adatokkal.</p>


            <p>Mindemellett amennyiben a felhasználó nem kívánja, hogy számítógépén cookie kerüljön elhelyezésre, úgy azt az általa használt böngésző beállításaiban letilthatja.</p>


            <p>A <a href="http://www.google.com/analytics">www.google.com/analytics</a> általi adatkezelésről a <a href="https://policies.google.com/?hl=hu">https://policies.google.com/?hl=hu</a> címen kérhető bővebb tájékoztatás.</p>


            <p>A “Hogyan használja fel a Google az adatokat, amikor Ön egy partnerünk oldalát vagy alkalmazását használja” című dokumentum az alábbi hivatkozáson érhető el: <a href="https://policies.google.com/technologies/partner-sites?hl=hu">https://policies.google.com/technologies/partner-sites?hl=hu</a></p>


            <p>A Sobras!.us honlapon az alábbi szolgáltatók a felsorolt sütiket helyezték el:</p>


            <table>
                <tbody>
                    <tr>
                        <td>
                        <p><strong>Szolgáltató</strong></p>
                        </td>
                        <td>
                        <p><strong>Cookie neve</strong></p>
                        </td>
                        <td>
                        <p><strong>Adatkezelés célja</strong></p>
                        </td>
                        <td>
                        <p><strong>Időtartama</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <p>Google Analytics</p>
                        </td>
                        <td>
                        <p>_ga</p>
                        </td>
                        <td>
                        <p>belső azonosító</p>
                        </td>
                        <td>
                        <p>2 év</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <p>Google Analytics</p>
                        </td>
                        <td>
                        <p>1P_JAR</p>
                        </td>
                        <td>
                        <p>weboldal statisztika, konverzió</p>
                        </td>
                        <td>
                        <p>1 hónap</p>
                        </td>
                    </tr>
                </tbody>
            </table>



            <p><strong>3.2. TÁJÉKOZTATÁS</strong></p>


            <p><strong>3.2.1. KAPCSOLATFELVÉTEL (E-MAIL VALAMINT TELEFON ÚTJÁN TÖRTÉNŐ TÁJÉKOZTATÁS)</strong></p>


            <p>Adatkezelő szolgáltatásai iránt érdeklődő érintettek e-mail valamint telefon útján kérhetnek további tájékoztatást az Adatkezelőtől. Adatkezelő az érintett kérdéseit az információkéréssel megegyező úton válaszolja meg. Az érintett az adatkezelés céljával összhangban önkéntesen járul hozzá ahhoz, hogy amennyiben a kapcsolatfelvétel során személyes adatait is Adatkezelő rendelkezésére bocsátja, úgy azon keresztül Adatkezelő vele kapcsolatba lépjen a kérdések megválaszolása vagy pontosítása érdekében.</p>


            <p><strong>Adatkezelés célja:</strong> információkérés, tájékoztatás, kapcsolattartás</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bekezdés a) pontja alapján az érintett hozzájárulása;</p>


            <p><strong>Érintettek köre:</strong> Adatkezelővel információkérés céljából kapcsolatba lépő személyek</p>


            <p><strong>Kezelt adatok köre:</strong> a megkeresés során önkéntesen megadott személyes adatok</p>


            <p><strong>Adatkezelés időtartama:</strong> az adatkezelés céljának megszűnéséig, de legfeljebb 1 évig</p>



            <p><strong>3.2.2. HÍRLEVÉLKÜLDÉS</strong></p>


            <p>Adatkezelő az érintett előzetes hozzájárulása esetén hírlevél útján nyújt tájékoztatást szolgáltatásairól és különleges ajánlatairól, illetve minden olyan információról, amely Adatkezelő véleménye szerint az érintett érdeklődésére tarthat számot. A hírlevélről az érintett bármikor leiratkozhat a hírlevélben található leírás szerint.</p>


            <p><strong>Adatkezelés célja:</strong> tájékoztató elektronikus levelek küldése</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bekezdés a) pontja alapján az érintett hozzájárulása</p>


            <p><strong>Érintettek köre:</strong> hírlevélre feliratkozó természetes személyek</p>


            <p><strong>Kezelt adatok köre:</strong> név, e-mail cím</p>


            <p><strong>Adatkezelés időtartama:</strong> a hírlevélre történő feliratkozástól az érintett kérésére történő törlésig (hírlevélről történő leiratkozásig)</p>


            <p><strong>3.3. ADATKEZELŐ ÁLTAL NYÚJTOTT SZOLGÁLTATÁSHOZ KAPCSOLÓDÓ ADATKEZELÉS</strong></p>


            <p><strong>3.3.1. SOBRAS! RENDSZER</strong></p>


            <p><strong>3.3.1.1. REGISZTRÁCIÓ</strong></p>


            <p>A SOBRAS! rendszerbe való regisztráció a felhasználó választásának megfelelően az adatok felhasználó általi megadásával, illetve az adatok Facebook-tól valamint Google-től való átvételével is lehetséges.</p>


            <p><strong>Adatkezelés célja:</strong> az elérhető Partneri szolgáltatások megjelenítése, rendelési és díjfizetési folyamatok biztosítása</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bek. b) pontja alapján a szerződés teljesítéséhez szükséges, vagy a szerződés megkötését megelőzően az érintett kérésére történő lépések megtételéhez szükséges adatkezelés</p>


            <p><strong>Érintettek köre:</strong> a Sobras! rendszer valamennyi felhasználója</p>


            <p><strong>Kezelt adatok köre:</strong> név, e-mail cím, telefonszám</p>


            <p><strong>Adatkezelés időtartama:</strong> a regisztrációtól számított 6. naptári év végéig</p>



            <p><strong>3.3.1.2. HELYMEGHATÁROZÁS</strong></p>


            <p>A SOBRAS! rendszer telepítését követő első használat során az adott eszköz engedélyt kér a felhasználótól, hogy helymeghatározási adataihoz a rendszer hozzáférhessen. Amennyiben a felhasználó hozzájárul a helymeghatározási adatokhoz való hozzáféréshez, a rendszer a felhasználó aktuális helyzetének megfelelően jeleníti meg a közelben elérhető ajánlatokat, illetve küld azokról azonnali értesítéseket. A Sobras! rendszer a felhasználó valamint eszközének helyzetét nem követi, kizárólag annak utolsó pozícióját használja fel az ajánlatok megjelenítése során.</p>

            <p><strong>Adatkezelés célja:</strong> automatikus helymeghatározás alapján történő ajánlatok és értestések megjelenítése</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bekezdés a) pontja alapján az érintett hozzájárulása</p>


            <p><strong>Érintettek köre:</strong> a Sobras! rendszer azon felhasználói, akik hozzájárultak a helymeghatározási adatok kezeléséhez</p>


            <p><strong>Kezelt adatok köre:</strong> az eszköz utolsó pozíciója</p>


            <p><strong>Adatkezelés időtartama:</strong> ideiglenes, a rendszer használata során</p>


            <p><strong>3.3.1.3. MEGRENDELÉS</strong></p>


            <p>A Sobras! renszer használatával, az aktuális kínálatból kiválasztott termék és annak mennyisége megjelölésével adhatja le megrendelését a felhasználó. A megrendelt ételek kifizetése online fizetéssel történik. Az online fizetést követően a Sobras! a foglalást visszaigazolja egy kódszám megküldésével, valamint annak megjelölésével, hogy a megkapott kódszámmal az étel hol és meddig vehető át.</p>


            <p>Adatkezelő kiemelt figyelmet fordít arra, hogy csak a megrendelések teljesítéséhez elengedhetetlenül szükséges személyes adatot kezeljen, valamint továbbítson partnerei részére, ennek köszönhetően az éttermek kizárólag a megrendelő nevét, a rendelési tételt, valamint a megrendeléshez tartozó kódszámot ismerik meg, míg az online fizetéshez szükséges személyes adatokat kizárólag a fizetési szolgáltató ismerheti meg.</p>


            <p><strong>Adatkezelés célja:</strong> megrendelés rögzítése és teljesítése</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bek. b) pontja alapján a szerződés teljesítéséhez szükséges, vagy a szerződés megkötését megelőzően az érintett kérésére történő lépések megtételéhez szükséges adatkezelés</p>


            <p><strong>Érintettek köre:</strong> a Sobras! rendszeren keresztül termékeket rendelő személyek</p>


            <p><strong>Kezelt adatok köre:</strong> megrendelő neve, rendelési tételek, rendelési kódszám</p>


            <p><strong>Adatkezelés időtartama:</strong> a megrendeléstől számított 6. naptári év végéig</p>


            <p><strong>Adattovábbítás: </strong>a megrendelő neve, a rendelési tételek valamint a rendelési kódszám továbbításra kerül az adott Partner részére</p>


            <p>Az online fizetés teljesítéséhez szükséges adatokat a felhasználó közvetlenül a Díjnet Zrt. beépülő modulján keresztül, a fizetési szolgáltató részére adja meg. A megadott online fizetési adatokat a Sobras! nem ismeri meg, így azokon adatkezelési műveletet nem hajt végre.</p>


            <p>A Díjnet Zrt. adatkezelésére vonatkozó adatkezelési tájékoztató az alábbi hivatkozáson érhető el: <a href="https://www.dijnet.hu/ekonto/control/adatkezelesi_tajekoztato">https://www.dijnet.hu/ekonto/control/adatkezelesi_tajekoztato</a></p>



            <p><strong>3.3.2. SZERZŐDÉSES PARTNEREK</strong></p>


            <p>Az Adatkezelő által nyújtott szolgáltatáshoz csatlakozó éttermek, mint szerződéses partnerek által rendelkezésre bocsátott, és a szolgáltatás használata során a felhasználók számára is elérhető adatok (az Partner neve, címe, további elérhetőségi adatai valamint aktuális ajánlatai) nem minősülnek személyes adatnak, így azok nem tartoznak jelen adatvédelmi tájékoztató hatálya alá.</p>


            <p>Adatkezelő kizárólag a Partnerrel kötött szolgáltatási szerződéshez kapcsolódóan, és az alábbiak szerint kezeli azon természetes személyek személyes adatait, akik az egyes éttermek kapcsolattartójaként kerültek kijelölésre.</p>


            <p><strong>Adatkezelés célja:</strong> kapcsolattartás szerződéses partnerekkel</p>


            <p><strong>Adatkezelés jogalapja:</strong> GDPR 6. cikk (1) bek. b) pontja alapján a szerződés teljesítéséhez szükséges, vagy a szerződés megkötését megelőzően az érintett kérésére történő lépések megtételéhez szükséges adatkezelés</p>


            <p><strong>Érintettek köre:</strong> szerződéses partner által kapcsolattartásra kijelölt természetes személy</p>


            <p><strong>Kezelt adatok köre:</strong> név, e-mail cím, telefonszám</p>


            <p><strong>Adatkezelés időtartama:</strong> az üzleti kapcsolat, illetve az érintett kapcsolattartói minőségének fennállását követő legfeljebb 5 évig</p>



            <p><strong>4. ADATFELDOLGOZÓK MEGNEVEZÉSE</strong></p>


            <p><strong>Tárhelyszolgáltatás:</strong></p>

            <p>Név: <strong>e-Communications Kft.</strong></p>

            <p>Cím: 1141 Budapest, Vízakna utca 4.</p>

            <p>Weboldal: <a href="https://marketing-online.hu/">https://marketing-online.hu/</a></p>


            <p><strong>Mobilfizetési rendszer:</strong></p>

            <p>Név: <strong>Díjnet Zrt.</strong></p>

            <p>Cím: 1117 Budapest, Budafoki út 107</p>

            <p>Weboldal: <a href="https://dijnet.hu">https://dijnet.hu</a></p>


            <p><strong>5. SZEMÉLYES ADATOK TÁROLÁSÁNAK MÓDJA</strong></p>


            <p>Adatkezelő számítástechnikai rendszerei és más adatmegőrzési helyei a székhelyén, valamint adatfeldolgozóinál találhatók meg. Adatkezelő a kezelt személyes adatokat az Európai Gazdasági Térség ("EGT") területén tárolja, valamint az EGT-n belüli adatfeldolgozókat vesz igénybe.</p>


            <p>Adatkezelő a személyes adatok kezeléséhez a szolgáltatás nyújtása során alkalmazott informatikai eszközöket úgy választja meg és üzemelteti, hogy a kezelt adat:</p>


            <p>a) az arra feljogosítottak számára hozzáférhető (rendelkezésre állás);</p>

            <p>b) hitelessége és hitelesítése biztosított (adatkezelés hitelessége);</p>

            <p>c) változatlansága igazolható (adatintegritás);</p>

            <p>d) a jogosulatlan hozzáférés ellen védett (adat bizalmassága) legyen.</p>


            <p>Adatkezelő az adatokat megfelelő intézkedésekkel védi különösen a jogosulatlan hozzáférés, megváltoztatás, továbbítás, nyilvánosságra hozatal, törlés vagy megsemmisítés, valamint a véletlen megsemmisülés, sérülés, továbbá az alkalmazott technika megváltozásából fakadó hozzáférhetetlenné válás ellen.</p>


            <p>Adatkezelő a különböző nyilvántartásaiban elektronikusan kezelt adatállományok védelme érdekében megfelelő technikai megoldással biztosítja, hogy a tárolt adatok – kivéve, ha azt törvény lehetővé teszi – közvetlenül ne legyenek összekapcsolhatóak és az érintetthez rendelhetőek.</p>

            <p>Adatkezelő a technika mindenkori fejlettségéhez igazodóan olyan műszaki, szervezési és szervezeti intézkedésekkel gondoskodik az adatkezelés biztonságának védelméről, amely az adatkezeléssel kapcsolatban jelentkező kockázatoknak megfelelő védelmi szintet nyújt.</p>



            <p><strong>6. AZ ÉRINTETTEK SZEMÉLYES ADATAIK KEZELÉSÉVEL KAPCSOLATOS JOGAIK</strong></p>


            <p><strong>Tájékoztatáshoz való jog</strong></p>


            <p>Valamennyi érintett tájékoztatást kérhet kezelt adataival kapcsolatosan. Adatkezelő az érintett erre irányuló kérelme esetén, személyazonosságának hitelt érdemlő igazolása és beazonosítását követően, soron kívül, de legkésőbb 30 napon belül tömör, átlátható, érthető és könnyen hozzáférhető formában, világosan és közérthetően megfogalmazva nyújt tájékoztatást.</p>


            <p><strong>Hozzáféréshez való jog</strong></p>


            <p>Az érintett jogosult arra, hogy visszajelzést kapjon arra vonatkozóan, miszerint személyes adatainak kezelése folyamatban van-e. Amennyiben ilyen adatkezelés folyamatban van az érintett jogosult arra, hogy a személyes adatokhoz és a következő információkhoz hozzáférést kapjon: az adatkezelés céljai; az érintett személyes adatok kategóriái; azon címzettek vagy címzettek kategóriái, akikkel, illetve amelyekkel a személyes adatokat Adatkezelő közölte, vagy a jövőben közli, ideértve különösen a harmadik országbeli címzetteket, illetve a nemzetközi szervezeteket; a személyes adatok tárolásának tervezett időtartama. Személyes adatok harmadik országba vagy nemzetközi szervezet részére történő továbbítása esetén az érintett jogosult arra, hogy tájékoztatást kapjon a továbbításra vonatkozó megfelelő garanciákról.</p>


            <p><strong>Helyesbítéshez való jog</strong></p>


            <p>Az érintett joga és kötelezettsége az esetlegesen hibásan bejegyzett adatok, vagy megváltozott adatok helyesbítését kérni. A személyazonosság hitelt érdemlő igazolása és az érintett személyének beazonosítását követően, a kérelemben foglaltak hitelt érdemlő alátámasztása esetén a helyesbítést Adatkezelő haladéktalanul végrehajtja, és erről érintettet tájékoztatja.</p>


            <p><strong>Törléshez való jog</strong></p>


            <p>Az érintett jogosult arra, hogy kérésére Adatkezelő indokolatlan késedelem nélkül törölje a rá vonatkozó személyes adatokat, ha:</p>

            <ul>
                <li>a személyes adatokra már nincs szükség abból a célból, amelyből azokat Adatkezelő gyűjtötte</li>
                <li>visszavonja az adatkezelés alapját képező hozzájárulását, és az adatkezelésnek nincs más jogalapja</li>
                <li>tiltakozik az adatainak kezelése ellen, és nincs elsőbbséget élvező jogszerű ok az adatkezelésre</li>
                <li>a személyes adatokat Adatkezelő jogellenesen kezelte.</li>
            </ul>


            <p>A szerződés tartama alatt, amennyiben az adatkezelés jogalapja a szerződés teljesítése illetve jogi kötelezettség, az érintett nem kérheti adatai törlését.</p>


            <p><strong>Az adatok korlátozásához való jog</strong></p>


            <p>Az adatok korlátozásának kérésére a következő esetekben kerülhet sor:</p>

            <ul>
                <li>az érintett vitatja a személyes adatok pontosságát, ez esetben a korlátozás arra az időtartamra vonatkozik, amely lehetővé teszi, a személyes adatok pontosságának ellenőrzését;</li>
                <li>az adatkezelés jogellenes, és az érintett ellenzi az adatok törlését, és ehelyett kéri azok felhasználásának korlátozását;</li>
                <li>Adatkezelőnek már nincs szüksége a személyes adatokra adatkezelés céljából, de az érintett igényli azokat jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez; vagy</li>
                <li>az érintett tiltakozott az adatkezelés ellen; ez esetben a korlátozás arra az időtartamra vonatkozik, amíg megállapításra nem kerül, hogy Adatkezelő jogos indokai elsőbbséget élveznek-e az érintett jogos indokaival szemben.</li>
            </ul>


            <p>Ha az adatkezelés korlátozás alá esik, a személyes adatokat a tárolás kivételével csak az érintett hozzájárulásával, vagy jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez, vagy más természetes vagy jogi személy jogainak védelme érdekében, vagy az Európai Unió, illetve valamely tagállam fontos közérdekéből lehet kezelni.</p>


            <p><strong>Az adathordozhatósághoz való jog</strong></p>


            <p>Az érintett kérheti, hogy a rá vonatkozó, Adatkezelő rendelkezésére bocsátott személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja, és ezeket az adatokat egy másik adatkezelőnek továbbítsa. Kérésének, személyazonosságának hitelt érdemlő igazolása és személyének beazonosítását követően, 30 napon belül eleget tesz Adatkezelő. Egy naptári éven belüli ismételt, vagy visszaélésszerű joggyakorlásnak minősülő kérelmek teljesítését azonban jogosult megtagadni az Adatkezelő, vagy kérelmének indokoltsága esetén az adminisztratív költségek megtérítését feltételül szabni annak teljesítéséhez.</p>


            <p><strong>Tiltakozáshoz való jog</strong></p>


            <p>Az érintett tiltakozhat személyes adatai kezelése ellen (i) ha a személyes adatok kezelése kizárólag Adatkezelőre vonatkozó jogi kötelezettség teljesítéséhez vagy jogos érdekeinek érvényesítéséhez szükséges; (ii) ha az adatkezelés célja közvetlen üzletszerzés, közvélemény-kutatás; vagy (iii) ha az adatkezelésre közérdekű feladat teljesítése érdekében kerül sor.</p>


            <p>A tiltakozás jogszerűségét Adatkezelő megvizsgálja, és ha a tiltakozás megalapozott, a kezelt személyes adatok zárolása mellett az adatkezelés megszüntetésre kerül, továbbá a tiltakozásról és az annak alapján tett intézkedésekről Adatkezelő értesíti mindazokat, akik részére a tiltakozással érintett személyes adatok korábban továbbításra kerültek.</p>


            <p><strong>Eljárási szabályok</strong></p>


            <p>Adatkezelő indokolatlan késedelem nélkül, de mindenféleképpen a kérelem beérkezésétől számított egy hónapon belül tájékoztatja az érintettet a GDPR 15–22. cikk szerinti kérelem nyomán hozott intézkedésekről. Szükség esetén, figyelembe véve a kérelem összetettségét és a kérelmek számát, ez a határidő további két hónappal meghosszabbítható.</p>


            <p>A határidő meghosszabbításáról Adatkezelő a késedelem okainak megjelölésével a kérelem kézhezvételétől számított egy hónapon belül tájékoztatja az érintettet. Ha az érintett elektronikus úton nyújtotta be a kérelmet, a tájékoztatás elektronikus úton kerül megadásra, kivéve, ha az érintett azt másként kéri.</p>


            <p>Ha Adatkezelő nem tesz intézkedéseket az érintett kérelme nyomán, késedelem nélkül, de legkésőbb a kérelem beérkezésétől számított egy hónapon belül tájékoztatja az érintettet az intézkedés elmaradásának okairól, valamint arról, hogy az érintett panaszt nyújthat be valamely felügyeleti hatóságnál, és élhet bírósági jogorvoslati jogával.</p>


            <p>Adatkezelő minden olyan címzettet tájékoztat az általa végzett valamennyi helyesbítésről, törlésről vagy adatkezelés-korlátozásról, akivel, illetve amellyel a személyes adatot közölte, kivéve, ha ez lehetetlennek bizonyul, vagy aránytalanul nagy erőfeszítést igényel. Az érintettet kérésére Adatkezelő tájékoztatja e címzettekről.</p>




            <p><strong>7. JOGORVOSLATI LEHETŐSÉGEK</strong></p>


            <p><strong>Panasz az Adatkezelőnél</strong></p>


            <p>Amennyiben úgy véli, hogy Adatkezelő nem tartja be, vagy megsérti a vonatkozó jogszabályi előírásokat, vagy az adatvédelmi tájékoztatóban vállalt kötelezettségeket, úgy azt jelezheti Adatkezelő alábbi elérhetőségein:</p>


            <p>Consil Korlátolt Felelősségű Társaság</p>

            <p>Levelezési cím: 2600 Vác, Mályva u 16.</p>

            <p>E-mail cím: info@sobras.us</p>


            <p>Adatkezelő az érintett panaszára soron kívül, de legkésőbb 30 napon belül írásban válaszol és a panaszolt tevékenységet indokoltság esetén orvosolja.</p>


            <p><strong>Bírósághoz fordulás joga</strong></p>


            <p>Az érintett a jogainak megsértése esetén Adatkezelő ellen (az érintett választása szerint Adatkezelő székhelye vagy az érintett lakóhelye szerint illetékes) bírósághoz fordulhat.</p>


            <p><strong>Adatvédelmi hatósági eljárás</strong></p>


            <p>Panasszal a Nemzeti Adatvédelmi és Információszabadság Hatóságnál lehet élni:</p>

            <p>Név: Nemzeti Adatvédelmi és Információszabadság Hatóság</p>

            <p>Székhely: 1125 Budapest, Szilágyi Erzsébet fasor 22/C.</p>



            <p><strong>8. EGYÉB RENDELKEZÉSEK</strong></p>


            <p>Az Adatvédelmi tájékoztató 2018. szeptember 5. napján lép hatályba.</p>
        </>
    }
    private getEn(){
        return <>
            { this.getHu() }
        </>
    }
}
